<!--
    描述： 概算价左侧的 预备费模块
    时间： xx
    created by ws
-->
<template>
	<div class="baseForm-layout">
		<div class="baseForm-header">预备费:
			<div class="btnGroups">
				<el-button size="mini"
						   @click="isLock = !isLock">{{ isLock ? '解锁' : '锁定' }}</el-button>
			</div>
		</div>
		<div class="baseForm-content">
			<el-tree :data="listData"
					 node-key="uid"
					 ref="tree"
					 class="custom-tree"
					 default-expand-all
					 :expand-on-click-node="false">
				<span class="custom-tree-node"
					  slot-scope="{ node, data }">
					<el-input type="text"
							  class="tree-input"
							  size="small"
							  ref="input"
							  v-model="data.sname"
							  :disabled="node.level<2 || isLock">
					</el-input>
					<span class="costName text-overflow"
						  v-if="node.level === 2"
						  :title="data.costPrice">费用: {{ data.costPrice }}元</span>
					<span class="btn-span"
						  v-if="!isLock">
						<el-button type="text"
								   size="mini"
								   v-if="node.level === 1"
								   @click="() => append(data)">
							<i class="el-icon-plus"></i>
						</el-button>
						<el-button type="text"
								   size="mini"
								   v-if="node.level === 2"
								   @click="() => remove(node,data)">
							<i class="el-icon-delete"></i>
						</el-button>
					</span>
				</span>
			</el-tree>
		</div>
	</div>
</template>

<script>

export default {
	name: 'prepare_cost_home',
	props: {
		// 项目ID
		projectId: {
			type: String,
			default: ''
		},
		// 其他费用数组
		listData: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	data() {
		return {
			treeData: [
				{
					sname: '其他费用',
					children: []
				}
			],
			isLock: true // 是否锁定
		}
	},
	methods: {
		// 新增节点
		append(data) {
			let newId
			let newChild = {
				uid: newId,
				sname: '子项目',
				pid: data.uid,
				projectId: this.projectId,
				sort: data.children.length + 1,
				levelType: 2,	// 层级
				projectQuantity: '',	// 工程量
				moneyBuild: '',	// 建筑工程费
				moneyEquipment: '',	// 设备购置费
				moneyInstall: '',	// 安装工程费
				moneyOther: 0,	// 其他费用
				costPrice: 0,
				unit: '',	// 单位
				remarks: '', // 备注
				costType: 2,	// 预备费类型
			}

			this.$emit('appendChild', data, newChild)
			// data.children.push(newChild)
		},
		// 移除节点
		remove(node, data) {
			let obj = JSON.parse(JSON.stringify(data))
			if (data.id) {
				this.$confirm('确认要删除当前数据吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.$emit('removeNode', node, obj)
					})
					.catch(() => {})
			} else {
				this.$emit('removeNode', node, obj)
				this.doRemove(node, data)
			}
		},
		// 前台移除
		doRemove(node, data) {
			// 父节点
			let parent = node.parent
			// 父节点的children
			let children = parent.data.children || parent.data
			// 找到当前项目
			let index = children.findIndex(d => d.uid === data.uid)
			children.splice(index, 1)
		}
	},
	created() {
		// 获取其他费用
		// this.getList()
	}
}
</script>

<style lang="less">
@import url('./cost.less');
</style>